












































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GeolocationPlugin } from 'vue-geolocation-api';
import { SearchVesselsParams } from '@/types/search/SearchVesselsParams';
import { CLEAR_VESSELS, SEARCH_VESSELS, SET_VESSELS_FILTER } from '@/store/vessels';
import { SEARCH_MARINAS } from '@/store/marinas';
import { SearchResultItem } from '@/types/SearchResultItem';
import { Marina } from '@/types/entities/Marina';
import PositionCoords = GeolocationPlugin.PositionCoords;
import LocationIcon from '@/svg/location.svg';
import RadiusIcon from '@/svg/radius.svg';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import UiKitModal from '@/components/UiKit/UiKitModal.vue';

@Component({
  components: { UiKitModal, LocationIcon, RadiusIcon, VueGoogleAutocomplete }
})
export default class VesselsLocationFilterModal extends Vue {
  @Prop() public name: string;

  protected location: PositionCoords = {
    latitude: 0,
    altitude: 0,
    longitude: 0,
    accuracy: 0,
    altitudeAccuracy: 0,
    heading: 0,
    speed: 0,
  };

  get coordinates() {
    return {
      lat: this.latitude,
      lng: this.longitude
    };
  }

  get filters(): SearchVesselsParams {
    return this.$store.state.vessels.filters;
  }

  get latitude() {
    const value = this.filters.within_distance_from!.split(',')[1];

    return !!value ? parseFloat(value) : this.location.latitude;
  }

  set latitude(value) {
    const filter = [ this.radius, value, this.longitude ].join(',');

    this.addFilter({ within_distance_from: filter });
  }

  get longitude() {
    const value = this.filters.within_distance_from!.split(',')[2];

    return !!value ? parseFloat(value) : this.location.longitude;
  }

  set longitude(value) {
    const filter = [ this.radius, this.latitude, value ].join(',');

    this.addFilter({ within_distance_from: filter });
  }

  get radius() {
    const value = this.filters.within_distance_from!.split(',')[0];

    return !!value ? value : 100;
  }

  set radius(value) {
    const filter = [ value, this.latitude, this.longitude ].join(',');

    this.addFilter({ within_distance_from: filter });
  }

  get radiusInMiles() {
    return (this.radius as number) * 1609;
  }

  get marinasMarkers() {
    return this.$store.state.marinas.items.data
      .map((marina: SearchResultItem<Marina>) => {
        return {
          lat: marina.attributes.lat,
          lng: marina.attributes.lng
        };
      });
  }

  public open() {
    this.$modal.show(this.name);

    if (!this.marinasMarkers.length) {
      this.$store.dispatch(SEARCH_MARINAS);
    }

    this.$geolocation
      .getCurrentPosition()
      .then(({ coords }) => this.location = coords);
  }

  protected clear() {
    this.addFilter({ within_distance_from: '' });

    this.$modal.hide(this.name);

    this.$store.dispatch(SEARCH_VESSELS);
  }

  protected apply() {
    this.$modal.hide(this.name);

    this.$store.commit(CLEAR_VESSELS);

    this.$store.dispatch(SEARCH_VESSELS);
  }

  protected centerChanged($event: any) {
    this.latitude = $event.latLng.lat();
    this.longitude = $event.latLng.lng();
  }

  protected addFilter(filters: SearchVesselsParams) {
    this.$store.commit(SET_VESSELS_FILTER, filters);
  }

  protected setAddress($event: any) {
    this.latitude = $event.latitude;
    this.longitude = $event.longitude;
  }
}
